import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { CircularProgress } from '@material-ui/core';

import Popup from '../../components/Popup';
import Sidebar from '../../components/SideBar';
import AlertModal from '../../components/Modal';
import RoundButton from '../../components/RoundButton';
import NavBar from '../../components/NavBarSearchSong';
import BlockUserModal from '../CustomerList/BlockUserModal';
import LogsModal from '../CustomerList/LogsModal';
import DeleteCustomerPopup from '../CustomerList/DeleteCustomerPopup';

import Settings from '../../assets/Settings.png';
import search from '../../assets/ic_search.png';
import moreInfrom from '../../assets/moreInfo.svg';
import DeleteIconSvg from '../../components/Svgs/DeleteIcon.svg';

import { formatDateToDisplay, _showAlert } from '../../utils';
import './Groups.scss';
import InfoPopUp from './InfoPopUp';
import { createGroup, useGetGroups, useGetGroupCustomers, deleteCustomerFromGroup } from '../../api/groups';
import { duplicateCustomer } from '../../api/customer';
import { default as ApiCaller } from '../../redux/ApiCaller';
import DeleteGroupPopup from './DeleteGroupPopup';
import SortIndicator from '../../components/SortIndicator';

const useStyles = makeStyles({
  table: {
    maxHeight: '90vh',
    borderRadius: 30,
  },
});

const GroupRow = ({ group, index, isSelected, onSelect }) => {
  const [isDeletePopUpVisible, setIsDeletePopUpVisible] = useState(false);
  return (
    <TableRow
      onClick={() => onSelect(group)}
      style={{
        cursor: 'pointer',
        backgroundColor: isSelected ? '#ccbbe6' : 'inherit'
      }}
    >
      <TableCell style={{ fontWeight: 'bold' }}>#{index + 1}</TableCell>
      <TableCell>{group.name || 'N/A'}</TableCell>
      <TableCell>{group.customercount || '0'}</TableCell>
      {group.name !== "All Customers" ?
        <TableCell>
          <DeleteIconSvg onClick={() => setIsDeletePopUpVisible(true)} alt="delete" />
        </TableCell>
        : <TableCell></TableCell>
      }
      {isDeletePopUpVisible && (
        <DeleteGroupPopup selectedGroup={group} setSelectedGroup={onSelect} setIsDeletePopUpVisible={setIsDeletePopUpVisible} />
      )}
    </TableRow>
  );
};

function Groups(props) {
  const classes = useStyles();
  const [groupSearchInput, setGroupSearchInput] = useState('');
  const [customerSearchInput, setCustomerSearchInput] = useState('');
  const [filteredGroups, setFilteredGroups] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [isActionPopUpOpen, setIsActionPopUpOpen] = useState(false);
  const [xPos, setxPos] = useState(0);
  const [yPos, setyPos] = useState(0);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [isAddGroupPopupOpen, setIsAddGroupPopupOpen] = useState(false);
  const [groupName, setGroupName] = useState('');
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [isDeletePopUpVisible, setIsDeletePopUpVisible] = useState(false);
  const [blockUserModalOpen, setBlockUserModalOpen] = useState(false);
  const [isUserUpadating, setIsUserUpading] = useState(false);
  const [logsModalOpen, setLogsModalOpen] = useState(false);
  const [isRefershing, setIsRefreshing] = useState(false);

  const history = useHistory();
  const dispatch = useDispatch();

  // Sorting state for groups table
  const [groupSortConfig, setGroupSortConfig] = useState({ key: null, direction: 'asc' });
  // Sorting state for customers table
  const [customerSortConfig, setCustomerSortConfig] = useState({ key: null, direction: 'asc' });

  const { groups, isGroupsValidating, mutateGroups } = useGetGroups();
  const { customers: groupCustomers, mutateCustomers, isCustomersValidating } = useGetGroupCustomers(selectedGroup?.id);

  useEffect(() => {
    if (groups?.length > 0 && !selectedGroup) {
      setSelectedGroup(groups[0]);
    }
  }, [groups, selectedGroup]);

  useEffect(() => {
    if (groups) {
      const filtered = groups.filter(group =>
        group.name?.toLowerCase().includes(groupSearchInput.toLowerCase())
      );
      setFilteredGroups(filtered);
    }
  }, [groupSearchInput, groups]);

  useEffect(() => {
    if (groupCustomers) {
      const filtered = groupCustomers.filter(customer =>
        customer.username?.toLowerCase().includes(customerSearchInput.toLowerCase()) ||
        customer.firstname?.toLowerCase().includes(customerSearchInput.toLowerCase()) ||
        customer.lastname?.toLowerCase().includes(customerSearchInput.toLowerCase())
      );
      setFilteredCustomers(filtered);
    }
  }, [customerSearchInput, groupCustomers]);

  const handleClose = () => {
    setOpen(false);
  };

  // Sorting functions for groups
  const handleGroupSort = (key) => {
    let direction = 'desc';
    let newKey = key;

    if (groupSortConfig.key === key) {
      if (groupSortConfig.direction === 'desc') {
        direction = 'asc';
      } else {
        newKey = null;
      }
    }

    setGroupSortConfig({ key: newKey, direction });
  };

  const sortGroups = (groups) => {
    if (!groupSortConfig.key || !Array.isArray(groups)) return groups;

    return [...groups].sort((a, b) => {
      if (groupSortConfig.key === 'name') {
        const nameA = a.name || '';
        const nameB = b.name || '';
        return groupSortConfig.direction === 'asc' ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
      }

      if (groupSortConfig.key === 'customercount') {
        const countA = parseInt(a.customercount) || 0;
        const countB = parseInt(b.customercount) || 0;
        return groupSortConfig.direction === 'asc' ? countA - countB : countB - countA;
      }

      return 0;
    });
  };

  // Sorting functions for customers
  const handleCustomerSort = (key) => {
    let direction = 'desc';
    let newKey = key;

    if (customerSortConfig.key === key) {
      if (customerSortConfig.direction === 'desc') {
        direction = 'asc';
      } else {
        newKey = null;
      }
    }

    setCustomerSortConfig({ key: newKey, direction });
  };

  const sortCustomers = (customers) => {
    if (!customerSortConfig.key || !Array.isArray(customers)) return customers;

    return [...customers].sort((a, b) => {
      if (customerSortConfig.key === 'username') {
        const usernameA = a.username || '';
        const usernameB = b.username || '';
        return customerSortConfig.direction === 'asc' ? usernameA.localeCompare(usernameB) : usernameB.localeCompare(usernameA);
      }

      if (customerSortConfig.key === 'name') {
        const nameA = (a.firstname || '') + ' ' + (a.lastname || '');
        const nameB = (b.firstname || '') + ' ' + (b.lastname || '');
        return customerSortConfig.direction === 'asc' ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
      }

      return 0;
    });
  };

  const handleMoreInfoClick = (event, customer) => {
    const { innerHeight: height } = window;
    let xPos = event.clientX;
    let yPos = event.clientY - event.target.offsetTop;

    if (yPos + 360 > height) {
      yPos = event.clientY - 330;
    }
    setIsActionPopUpOpen(true);
    setxPos(xPos);
    setyPos(yPos);
    setSelectedCustomer(customer);
  };

  const handleCreateGroup = async () => {
    try {
      await createGroup({ name: groupName, description: "" });
      mutateGroups();
      setIsAddGroupPopupOpen(false);
      setGroupName('');
    } catch (error) {
      console.log('error===>', error);
      setIsAddGroupPopupOpen(false);
      setGroupName('');
    }
  };

  const handleDuplicateClick = async () => {
    try {
      await duplicateCustomer(selectedCustomer.id, {
        suffix: 'test',
        groups: [selectedGroup.id]
      });
      mutateGroups();
      mutateCustomers();
      setIsActionPopUpOpen(false);
    } catch (error) {
      console.log('error===>', error);
      setIsActionPopUpOpen(false);
    }
  };

  const handleCustomerDetails = () => {
    history.push({
      pathname: '/customer-details',
      state: selectedCustomer,
    });
  };

  const handleCustomerEditPage = () => {
    history.push({
      pathname: '/update-customer',
      state: selectedCustomer,
    });
  };

  const handleRefreshClick = async () => {
    try {
      setIsRefreshing(true);
      const data = await ApiCaller(`/v1/admin/customer/${selectedCustomer.id}/actions/restart_device`, 'POST', {});
      console.log(data);
      setIsRefreshing(false);
    } catch (error) {
      setIsRefreshing(true);
      _showAlert(error.message, 'error');
    }
  };

  const handleSetExirationDate = async (e) => {
    try {
      setIsUserUpading(true);
      const expiration_date = Math.floor(e.getTime() / 1000);
      const payload = {
        id: selectedCustomer?.id,
        expiration_date: Math.floor(e.getTime() / 1000),
      };
      await ApiCaller('/v1/admin/customer', 'post', payload);

      const updatedCustomer = {
        id: selectedCustomer.id,
        name: selectedCustomer.name,
        email: selectedCustomer.email,
        address: selectedCustomer.address,
        userRole: selectedCustomer.userRole,
        createdAt: selectedCustomer.createdAt,
        firstname: selectedCustomer.firstname,
        lastname: selectedCustomer.lastname,
        business_name: selectedCustomer.business_name,
        username: selectedCustomer.username,
        phone: selectedCustomer.phone,
        expiration_date: expiration_date,
        is_online: selectedCustomer.is_online,
        status: selectedCustomer.status,
      };

      dispatch({ type: 'CUSTOMER_LIST', payload: '' });
      setIsUserUpading(false);
      setBlockUserModalOpen(false);
    } catch (error) {
      setBlockUserModalOpen(false);
      setIsUserUpading(false);
      _showAlert(error.message, 'error');
    }
  };

  const handleShuffle = async () => {
    try {
      setIsRefreshing(true);
      const data = await ApiCaller(`/v1/admin/customer/${selectedCustomer.id}/actions/shuffle`, 'POST', {
        shuffle: true,
      });
      console.log(data);
      setIsRefreshing(false);
    } catch (error) {
      setIsRefreshing(true);
      _showAlert(error.message, 'error');
    }
  };

  const onRemoveIconClick = async () => {
    setIsActionPopUpOpen(false);
    try {
      console.log("selectedCustomer.id", selectedCustomer.id);
      console.log("selectedGroup.id", selectedGroup.id);
      await deleteCustomerFromGroup(selectedCustomer.id, selectedGroup.id);
      mutateCustomers();
      mutateGroups();
      _showAlert('Customer removed from group successfully.', 'success');
    } catch (error) {
      console.log(error);
      _showAlert(error.message, 'error');
    }
  };

  const onDeleteIconClick = () => {
    setIsDeletePopUpVisible(true);
    setIsActionPopUpOpen(false);
  };

  return (
    <>
      {isRefershing && (
        <div className="modalBackDrop" style={{ zIndex: 10 }}>
          <CircularProgress />
        </div>
      )}
      <div className="main">
        <div className="sidebar">
          <Sidebar />
        </div>
        <AlertModal open={open} onClose={handleClose} handelDelete={() => { }} />
        {/* {isLoading && <LoaderSpinner />} */}
        <div className="leftPortion">
          <NavBar data="Groups" icon={Settings} currentRouteName="Customers" breadcrumbsPath="Groups" />
          <div className="content">
            <div className='edit-row-container' >
              <div className="groups-search-container" >
                <div className="search_row groups-search-input">
                  <input
                    className="input_field search_input"
                    placeholder="Search group here..."
                    type="text"
                    value={groupSearchInput}
                    onChange={(e) => setGroupSearchInput(e.target.value)}
                  />
                  <img src={search} alt="search" />
                </div>
                <RoundButton btnText="Add Group" handleClick={() => setIsAddGroupPopupOpen(true)} />
              </div>
              <div className="customer-search-container">
                <div className="search_row">
                  <input
                    className="input_field search_input"
                    placeholder="Search customers in group..."
                    type="text"
                    value={customerSearchInput}
                    onChange={(e) => setCustomerSearchInput(e.target.value)}
                  />
                  <img src={search} alt="search" />
                </div>
              </div>
            </div>
            <div className="wrap_tbl remove_padding">
              <TableContainer className="tbl_wraper groups-table" component={Paper}>
                <Table className={classes.table} stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Result</TableCell>
                      <TableCell
                        onClick={() => handleGroupSort('name')}
                        style={{ cursor: 'pointer', userSelect: 'none' }}
                      >
                        Group Name<SortIndicator sortConfig={groupSortConfig} columnKey="name" />
                      </TableCell>
                      <TableCell
                        onClick={() => handleGroupSort('customercount')}
                        style={{ cursor: 'pointer', userSelect: 'none' }}
                      >
                        Members<SortIndicator sortConfig={groupSortConfig} columnKey="customercount" />
                      </TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Array.isArray(filteredGroups) ? (
                      filteredGroups.length > 0 ? (
                        sortGroups(filteredGroups).map((group, index) => (
                          <GroupRow
                            key={index}
                            group={group}
                            index={index}
                            isSelected={selectedGroup?.id === group.id}
                            onSelect={setSelectedGroup}
                          />
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={3} style={{ textAlign: 'center' }}>{isGroupsValidating ? 'Loading...' : 'No groups found'}</TableCell>
                        </TableRow>
                      )
                    ) : null}
                  </TableBody>
                </Table>
              </TableContainer>
              <TableContainer
                className="tbl_wraper customer-table"
                component={Paper}
              >
                <Table className={classes.table} stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Result</TableCell>
                      <TableCell
                        onClick={() => handleCustomerSort('username')}
                        className="customer-table-header"
                      >
                        Username<SortIndicator sortConfig={customerSortConfig} columnKey="username" />
                      </TableCell>
                      <TableCell
                        onClick={() => handleCustomerSort('name')}
                        className="customer-table-header"
                      >
                        Name<SortIndicator sortConfig={customerSortConfig} columnKey="name" />
                      </TableCell>
                      <TableCell>Address</TableCell>
                      <TableCell>Connection</TableCell>
                      <TableCell>Expiry Date</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Array.isArray(filteredCustomers) && filteredCustomers.length > 0 ? (
                      sortCustomers(filteredCustomers).map((customer, index) => (
                        <TableRow key={index}>
                          <TableCell style={{ fontWeight: 'bold' }}>#{index + 1}</TableCell>
                          <TableCell>{customer.username || 'N/A'}</TableCell>
                          <TableCell>{customer.firstname + ' ' + customer.lastname || 'N/A'}</TableCell>
                          <TableCell>{customer.address || 'N/A'}</TableCell>
                          <TableCell>
                            <span
                              style={{ backgroundColor: customer?.is_online ? '#1CC700' : '#C70000' }}
                              className="indication_circle"
                            ></span>
                          </TableCell>
                          <TableCell>{customer.expiration_date ? formatDateToDisplay(customer.expiration_date * 1000) : '-'}</TableCell>
                          <TableCell>
                            <img onClick={(e) => handleMoreInfoClick(e, customer)} alt="customer details" src={moreInfrom} />
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={6} style={{ textAlign: 'center' }}>
                          {isCustomersValidating ? 'Loading...' : 'No customers in this group'}
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>
      </div>
      {
        <Popup
          open={isAddGroupPopupOpen}
          onClose={() => {
            setIsAddGroupPopupOpen(false);
            setGroupName('');
          }}
        >
          <div className="create_group">
            <p className="header">Create Group</p>
            <div className="group_container">
              <input
                className="group_input"
                value={groupName}
                placeholder="Group Name"
                type="text"
                onChange={(e) => setGroupName(e.target.value)}
              />
            </div>
            <RoundButton className="add-btn" btnText="Create" handleClick={() => handleCreateGroup()} />
          </div>
        </Popup>
      }
      {isActionPopUpOpen && (
        <InfoPopUp
          setIsActionPopUpOpen={setIsActionPopUpOpen}
          xPos={xPos}
          yPos={yPos}
          onDuplicateClick={handleDuplicateClick}
          handleCustomerDetails={handleCustomerDetails}
          handleCustomerEditPage={handleCustomerEditPage}
          setBlockUserModalOpen={setBlockUserModalOpen}
          setLogsModalOpen={setLogsModalOpen}
          handleRefreshClick={handleRefreshClick}
          onDeleteIconClick={onDeleteIconClick}
          onRemoveIconClick={onRemoveIconClick}
          handleShuffle={handleShuffle}
          showRemove={selectedGroup?.name !== "All Customers"}
        />
      )}
      {blockUserModalOpen && (
        <BlockUserModal
          isLoading={isUserUpadating}
          setBlockUserModalOpen={setBlockUserModalOpen}
          setBlockUserDate={handleSetExirationDate}
        />
      )}
      {logsModalOpen && <LogsModal setLogsModalOpen={setLogsModalOpen} selectedCustomer={selectedCustomer} />}
      {isDeletePopUpVisible && (
        <DeleteCustomerPopup selectedCustomer={selectedCustomer} setIsDeletePopUpVisible={setIsDeletePopUpVisible} />
      )}
    </>
  );
}

export default Groups;

